/**
 * Ask 3 (Claude Design return 2026-10-19): the Settings location modal, opened from the
 * two new doors that are not the Training Profile screen: the Today hero's "Add location"
 * and the Settings "Your data > Location" row.
 *
 * It is the same `LocationModal` the Training Profile opens, saved the same way
 * (`useSettingsPersist().saveFields`, the atomic 4-key write that also merges the new
 * coordinates into the shared athlete context), so a saved location reaches
 * `useHeroWeather` and the Weather row appears. Mount it only while it is open: that keeps
 * `useSettingsPersist` from being instantiated on every Today or first screen.
 */

import { useAthleteContext } from '../../../hooks/useAthleteContext';
import { useSettingsPersist, type SettingKey } from '../../../lib/settingsPersist';
import { LocationModal } from '../LocationModal';

export function LocationEditModal({ onClose }: { onClose: () => void }) {
  const { raw } = useAthleteContext();
  const { saveFields } = useSettingsPersist();
  const city = typeof raw._city === 'string' && raw._city.trim() !== '' ? raw._city : null;
  const onSave = async (updates: Partial<Record<SettingKey, unknown>>) => {
    await saveFields(updates);
    onClose();
  };
  return <LocationModal initialCity={city} onSave={onSave} onClose={onClose} />;
}
